import Swiper, { Navigation, Virtual, Autoplay, EffectFade } from 'swiper';

Swiper.use([Navigation, Virtual, Autoplay, EffectFade]);

// import "./aptumistic/accordion";
import "./aptumistic/menu";
import "./aptumistic/mobile-menu";
import "./aptumistic/responsive-background-image";
import "./aptumistic/mega-menu";
import "./aptumistic/content-accordion";
import "./aptumistic/fancybox";
import "./aptumistic/slick";
import "./aptumistic/isotope";
import "./aptumistic/modal";
import "./aptumistic/garage-cell";
import "./aptumistic/multiple-select";
import "./aptumistic/taxonomy-filter";
import "./aptumistic/hot-link";
import "./aptumistic/touch-enabled";
import "./aptumistic/email-obfuscator";
import "./aptumistic/helpers";
import "./aptumistic/section-featured-products-filter";
import "./aptumistic/section-featured-products";
import "./aptumistic/section-image-banner";

jQuery(function() {
	if ( jQuery('body').hasClass('blog') && jQuery('li.cat-item-all').length ) {
		jQuery('li.cat-item-all').addClass('current-cat');
	}
});
